export class Controller {

    /** @ngInject */
    constructor(UsersResource,$window) {
        this.UsersResource = UsersResource;
        this.$window = $window;
    }

    $onInit() {
    }

    generateBackupCodes() {
        const {companyId, companyUserId} = this.resolve;
		this.isSaving = true;
		var a = document.createElement("a");
		document.body.appendChild(a);
		this.UsersResource.getUsersBackupOtps(companyId,companyUserId).then((response)=>{
			var filename = this.getFileNameFromHttpResponse(response);
			console.log(filename);
			var fileURL = this.$window.URL.createObjectURL(response.data);
			a.href = fileURL;
			a.download = filename;
			a.click();
			setTimeout(function() { this.$window.URL.revokeObjectURL(fileURL); }, 100);
			this.close();
		}).finally(() => this.isSaving = false)
    }
    getFileNameFromHttpResponse(httpResponse) {
		var contentDispositionHeader = httpResponse.headers('Content-Disposition');
		var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
		return result.replace(/"/g, '');
	}
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/generate-backup-codes/generate-backup-codes.controller.js